'use client';
import { useEffect, useRef } from 'react';
import { useFormSubmitEvent } from 'hooks/analytics/use-form-submit-event';
import { searchMyEquipmentGATracking } from '../../utils/utils';
import { useMyEquipmentContext } from 'components/my-equipment/my-equipment-search-pagination-context';

const MyEquipmentGATracking = () => {
  const { paginatedEquipmentList, searchValue } = useMyEquipmentContext();
  const { fireEvent } = useFormSubmitEvent();
  const hasRendered = useRef(false);

  useEffect(() => {
    if (!hasRendered.current && searchValue) {
      fireEvent(
        searchMyEquipmentGATracking(searchValue, paginatedEquipmentList)
      );
      hasRendered.current = true;
    }
  }, [searchValue, paginatedEquipmentList, fireEvent]);
  return null;
};

export default MyEquipmentGATracking;
